<template>
    <div>
        <b-card>
            <b-tabs content-class="mt-3" pills card>
                <b-tab active>
                    <template #title>
                        <i class="fas fa-user mr-1"></i> Customer Review
                    </template>
                    <CustomerRating />
                </b-tab>

                <b-tab>
                    <template #title>
                        <i class="fas fa-star mr-1"></i> Rating Review
                        Preferences
                    </template>
                    <RatingPreference />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import CustomerRating from "./CustomerRating.vue";
import RatingPreference from "./RatingPreference.vue";
export default {
    name: "ReviewPage",
    components: {
        CustomerRating,
        RatingPreference,
    },
};
</script>

<style scoped>
.container {
    max-width: 800px;
}
</style>
